import { createContext, createEffect, createMemo, createSignal, JSX, Setter } from "solid-js"
import { FlaggingClient, GatingContextStore } from "../types"

export const GatingContext = createContext<GatingContextStore>()

type UnsubscribeCallback = () => void
type SubscribeCallback<T> = (client: T, setIsLoading: Setter<boolean>) => UnsubscribeCallback
type Props<T extends FlaggingClient> = {
	factory: () => T
	isReady: (client: T) => boolean
	initialize: (client: T, setIsLoading: Setter<boolean>) => void
	subscribe: SubscribeCallback<T>
	children: JSX.Element
}

export function GatingProvider<T extends FlaggingClient>(props: Props<T>) {
	const client = createMemo(() => props.factory())

	const [isLoading, setIsLoading] = createSignal(!props.isReady(client()))

	createMemo(() => props.initialize(client(), setIsLoading))

	createEffect(() => props.subscribe(client(), setIsLoading))

	const contextValue = {
		client,
		isLoading,
	}

	return <GatingContext.Provider value={contextValue}>{props.children}</GatingContext.Provider>
}
